<template>
  <div class="auctionItem_w">
    <div class="head">
      <div class="picture_w" :style="randomRgb">
        <el-image
          class="picture"
          :src="
            data.cover
              ? data.cover + '!283'
              : require('@/assets/images/QaKkPnoKQkBK7pdG.jpeg')
          "
          alt=""
          lazy
        />
      </div>

      <h3 class="title text_ellipsis c_1A1A1A">{{ data.title }}</h3>
    </div>
    <div class="main">
      <div class="desc_item ">
        <span class="key_label white_s_nowrap fz14 c_808080">当前价</span>
        <div class="text_ellipsis c_CF3342">
          <span class="fz20 font_w_bold">
            ￥{{ numTurnText(data.currentPrice) }}</span>
          <span class="fz14" style="margin: 0 0 0 5px">元</span>
          <span
            v-show="data.priceUnitDesc"
            class="fz14"
          >{{ '/'+data.priceUnitDesc }}</span>
          <span
            v-if="data.priceUnit === 'zongjia'"
            class="fz14"
            style="margin:0 0 0 5px"
          >({{ priceUnitKey[data.priceUnit] }})</span>
        </div>
      </div>
      <div class="desc_item fz14 c_808080">
        <span class="key_label white_s_nowrap  ">起拍价</span>
        <span class="text_ellipsis   ">￥{{ numTurnText(data.floorPrice) }}元</span>

      </div>
      <div class="desc_item text_ellipsis fz14 c_808080">
        <span class="key_label white_s_nowrap " v-html="stateTimeDesc(data.auctionState)">
          <!-- {{ stateTimeDesc(data.auctionState) }} -->
        </span>
        <span style="margin-left:4px">
          <span>{{ stateTime(data.auctionState) }}</span> <span class="time" />
        </span>
      </div>

      <div class="optional d_flex justify_content_sb align_item_c fz14 c_808080">
        <div class="d_flex align_item_c ">
          <i class="el-icon-location-outline fz18" /><span
            class="location_name fz14"
          >{{ data.regionName }}</span>
        </div>
        <div class="state fz14 text_center c_fff" :class="stateStyle(data.auctionState)">{{ data.auctionStateDesc }}</div>
      </div>
    </div>
    <div class="bottom d_flex text_center fz12 c_808080">
      <span class="data_count">{{ data.statis.onlookerCnt }}次围观</span>
      <span class="data_count">{{ data.statis.applyCnt }}人报名</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { numTurnText, formatDate } from '@/utils'

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      randomRgb: {
        backgroundColor:
          'rgb(' +
          Math.floor(Math.random() * 130 + 110) +
          ',' +
          Math.floor(Math.random() * 130 + 110) +
          ',' +
          Math.floor(Math.random() * 130 + 110) +
          ')'
      }
    }
  },
  computed: {
    ...mapGetters(['priceUnitKey', ]),



    // 状态时间文本
    stateTime() {
      return function(stateCode) {
        switch (stateCode) {
          case 0:
             return this.stateTimeLabel(stateCode,this.data.applyStartTime);
          case 1:
             return this.stateTimeLabel(stateCode,this.data.applyEndTime);
          case 2:
             return this.stateTimeLabel(stateCode,this.data.auctionStartTime);
          case 3:
          case 4:
          case 5:
             return this.stateTimeLabel(stateCode,this.data.auctionEndTime);
        }
      }
    },

    stateTimeLabel(){
      return function(stateCode,date){
        let transTime = ''
        let transLabel = ''

        let time = new Date(date).getTime() // 状态时间戳
        let timeY = new Date(date).getFullYear()  // 年份
        let timeM = new Date(date).getMonth() + 1  // 月份

        switch(stateCode){
          case 0:
            transTime = `${formatDate(new Date(date), 'yyyy-MM-dd')} ${formatDate(new Date(date), 'hh:mm')}`;
            transLabel = ' 开始'
            break;
          case 1:
            transTime = `${formatDate(new Date(date), 'yyyy-MM-dd')} ${formatDate(new Date(date), 'hh:mm')}`;
            transLabel = ' 结束'
            break;
          case 2:
            transTime = `${formatDate(new Date(date), 'yyyy-MM-dd')} ${formatDate(new Date(date), 'hh:mm')}`;
            transLabel = ' 开始'
            break;
          case 3:
            transLabel = ' 结束'
          case 4:
          case 5:
            transTime = `${formatDate(new Date(date), 'yyyy-MM-dd hh:mm')}`;
            break;
        }

        let timeD =  new Date(time).getDate() // 状态时间的几号
        let nowD = new Date().getDate() // 当前几号

        console.log('stateTimeLabel',timeD,nowD)
        // 以下情况只在当前年和当前月有效
        if(new Date().getFullYear() === timeY && new Date().getMonth() + 1 === timeM){
          // if(timeD === nowD){
          //   transTime = `${formatDate(new Date(time), 'hh:mm')}`;

          //   transLabel = '今天 '
          // } else if(timeD - nowD >= 1 && timeD - nowD < 2 ){
          //   transTime = `${formatDate(new Date(time), 'hh:mm')}`;

          //   transLabel = '明天 '
          // } else {
          //   transTime = `${formatDate(new Date(time), 'MM月dd日 hh:mm')}`;
          // }

          transTime = `${formatDate(new Date(time), 'MM月dd日 hh:mm')}`;


        } else if(new Date().getFullYear() === timeY){  // 是当前年不是当前月
          transTime = `${formatDate(new Date(time), 'MM月dd日 hh:mm')}`;
        }


        return transTime + transLabel
      }
    },

    // 状态时间文本
    stateTimeDesc() {
      return function(stateCode) {
        switch (stateCode) {
          case 0:
          case 1:
          case 2 :
          case 3:
            return '预&nbsp;&nbsp;&nbsp;计'
          case 4:
            return '中&nbsp;&nbsp;&nbsp;止'
          case 5:
            return '结&nbsp;&nbsp;&nbsp;束'
        }
      }
    },

    // 状态颜色
    stateStyle: function() {
      return function(stateCode) {
        switch (stateCode) {
          case 0:
          case 1:
            return 'bc_22D179'
          case 3 :
            return 'bc_EF3946'
          case 2:
          case 4:
          case 5:
            return 'bc_808080'
        }
      }
    },

    // 格式化金额（中文）
    numTurnText: function() {
      return function(num) {
        return numTurnText(num)
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.auctionItem_w {
  width: 285px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  margin:0 20px 20px 0;
  box-sizing: border-box;
  &:nth-child(4n){
    margin: 0 0 20px 0;
  }
  &:hover {
    cursor: pointer;
  }
  .head {
    .picture_w {
      position: relative;
      height: 150px;
    }
    .picture {

      ::v-deep img {
        position: static; // 兼容ie
        display: block;
        width: 283px;
        height: 150px;
        transform: none; // 兼容ie
      }
    }
    .title {
      padding: 15px;
    }
  }
  .main {
    padding: 0 15px;
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    .desc_item {
      display: flex;
      align-items: center;
      margin: 15px 0;
      .time {
        margin-left: 10px;
      }
    }
    .key_label {
      margin-right: 8px;
    }
    .state {
      width: 80px;
      height: 26px;
      line-height: 26px;
      margin-right: -16px;
    }
    .optional {
      margin-bottom: 10px;
      .location_name {
        margin-left: 6px;
      }
    }
  }
  .bottom {
    .data_count {
      padding: 10px 0;
      flex-basis: 50%;
      &:first-child {
        border-right: 1px solid #e6e6e6;
      }
    }
  }
}
</style>
